import React, { Component } from 'react';
import Ace from './ace';
import splitClassName from './helpers/split-class-name';
import noop from '../utils/noop';
import cleanupAnnotations from './helpers/cleanup-annotations';

class AceEditor extends Component {
  editor;
  editorNodeRef;
  silentMode;

  static defaultProps = {
    className: '',
    style: {},
    mode: 'text',
    theme: 'chrome',
    options: {},
    defaultValue: '',
    value: '',
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    onValidate: noop,
    onPaste: noop,
  };

  constructor(props) {
    super(props);

    this.editorNodeRef = React.createRef();
    this.editor = null;
    this.silentMode = false;
  }

  componentDidMount() {
    const editor = Ace.edit(this.editorNodeRef.current);
    const {
      className,
      mode,
      theme,
      options,
      defaultValue,
      value,
      onChange,
      onFocus,
      onBlur,
      onPaste,
      onValidate,
    } = this.props;

    const newClassNames = splitClassName(className);

    newClassNames.forEach((newClassName) => {
      editor.container.classList.add(newClassName);
    });

    editor.session.setMode(`ace/mode/${mode}`);
    editor.setTheme(`ace/theme/${theme}`);
    editor.setOptions(options);
    editor.setValue(value || defaultValue, 1);

    editor.on('change', () => {
      if (!this.silentMode) {
        const editorValue = editor.getValue();
        if (!editorValue) {
          editor.getSession().setAnnotations([]);
        }
        onChange(editorValue);
      }
    });

    editor.on('focus', onFocus);
    editor.on('blur', onBlur);
    editor.on('paste', onPaste);

    editor.getSession().on('changeAnnotation', () => {
      const { session } = editor;
      const editorAnnotations = editor.getSession().getAnnotations();
      const annotations = cleanupAnnotations(editorAnnotations);

      if (editorAnnotations.length !== annotations.length) {
        session.setAnnotations(annotations);
      }

      onValidate({ annotations, value: editor.getValue(), session });
    });

    this.editor = editor;
  }

  componentDidUpdate(prevProps) {
    const { editor } = this;
    const { className, mode, theme, value } = this.props;

    if (prevProps.className !== className) {
      const oldClassNames = splitClassName(prevProps.className);
      const newClassNames = splitClassName(className);

      oldClassNames.forEach((oldClassName) => {
        editor.container.classList.remove(oldClassName);
      });

      newClassNames.forEach((newClassName) => {
        editor.container.classList.add(newClassName);
      });
    }

    if (prevProps.value !== value && editor.getValue() !== value) {
      const selection = editor.session.selection.toJSON();

      this.silentMode = true;
      editor.setValue(value, 1);
      editor.session.selection.fromJSON(selection);
      this.silentMode = false;
    }

    if (prevProps.mode !== mode) {
      editor.session.setMode(`ace/mode/${mode}`);
    }

    if (prevProps.theme !== theme) {
      editor.setTheme(`ace/theme/${theme}`);
    }
  }

  componentWillUnmount() {
    this.editor.destroy();
    this.editor = null;
  }

  render() {
    const { style } = this.props;
    return <div ref={this.editorNodeRef} style={style} translate="no" />;
  }
}

export default AceEditor;
